import { Button, Row } from "antd";
import React, { useState } from "react";
import TmsModal from "../../../../../../components/tms-customs/tms-modal";
import TmsCreatedBankAccountList from "../created-inner-pages/fdr-bank-account-list";
import TmsBankAccountCreation from "../creation-inner-pages/tms-bank-account-creation";
const BankAccountIndex = () => {
  const [visible, setVisible] = useState(false);

  return (
    <div>
      <Row justify="start">
        <Button
          type="primary"
          onClick={() => {
            setVisible(true);
          }}
        >
          New Bank Account
        </Button>
      </Row>
      <br />
      {!visible && <TmsCreatedBankAccountList />}
      <TmsModal
        centered={true}
        width="80%"
        closable={false}
        visible={visible}
        title={"New Bank Account Creation "}
        onClose={() => {
          setVisible(false);
        }}
      >
        {visible && <TmsBankAccountCreation setVisible={setVisible} />}
      </TmsModal>
    </div>
  );
};

export default BankAccountIndex;
